import { useState, useCallback, FC } from 'react';
import Modal from 'react-modal';

const useErrorModal = () => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [title, setTitle] = useState<string>('');

  const openErrorModal = useCallback((message: string, title: string = 'Fehler') => {
    setTitle(title);
    setMessage(message);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const ErrorModal: FC = () => (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      className="absolute top-1/2 left-1/2 max-w-md w-full -translate-x-1/2 -translate-y-1/2 bg-white p-5 rounded-lg shadow-lg"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
      contentLabel="Fehlermeldung"
    >
      <div className="flex flex-col items-center">
        <h2 className="text-lg font-semibold mb-4">{title}</h2>
        <p className="mb-6">{message}</p>
        <button
          onClick={closeModal}
          className="bg-red-500 text-white font-bold py-2 px-4 rounded hover:bg-red-700 transition ease-in-out duration-150"
        >
          Schließen
        </button>
      </div>
    </Modal>
  );

  return { openErrorModal, ErrorModal };
};

export default useErrorModal;
